import scrollTo from './scrollto';
import loader from './loader';

const getFloors = (selector) => {
	const btn = document.querySelectorAll(selector);
	const selected = [];

	btn.forEach((el) => {
		const { floorNumber } = el.dataset;
		const active = el.classList.contains('active');
		if (floorNumber !== 'all' && active) {
			selected.push(floorNumber);
		}
	});

	return selected;
};

const getRanges = (ranges) => {
	const range = {};
	Object.entries(ranges).forEach(([k, v]) => {
		const minRange = document.querySelector(`input[name="${k}"].${v.min}`).value;
		const maxRange = document.querySelector(`input[name="${k}"].${v.max}`).value;

		range[k] = { max: maxRange, min: minRange };
	});

	return range;
};

const findApartaments = (selector, floors, ranges) => {
	const findBtn = document.getElementById(selector);
	if (!findBtn) return;

	findBtn.onclick = () => {
		loader('add');

		const { nonce, action } = findBtn.dataset;
		const floor = getFloors(floors);
		const range = getRanges(ranges);
		const container = document.getElementById('apartaments');
		const anchor = document.getElementById('anchor');

		const formData = new FormData();
		formData.append('nonce', nonce);
		formData.append('action', action);
		formData.append('floor', JSON.stringify(floor));
		formData.append('range', JSON.stringify(range));

		const xhr = new XMLHttpRequest();

		xhr.onreadystatechange = () => {
			if (xhr.readyState === 4 && xhr.status === 200) {
				const responseJson = JSON.parse(xhr.responseText);
				if (responseJson.success) {
					container.innerHTML = responseJson.data.html;
					scrollTo(anchor, 'always');
					const event = new Event('htmlChange');
					document.dispatchEvent(event);
				}
				loader('remove');
			}
		};

		/* global findPosts */
		/* eslint no-undef: "error" */

		xhr.open('POST', findPosts.ajaxUrl, true);
		xhr.send(formData);

		const url = new URL(findPosts.url);
		window.history.replaceState(null, null, url);
	};
};

const rangeMin = 'js-range-min';
const rangeMax = 'js-range-max';

const params = {
	area: { min: rangeMin, max: rangeMax },
	rooms: { min: rangeMin, max: rangeMax },
};

document.addEventListener('DOMContentLoaded', findApartaments('find', '[data-floor-number]', params));

export { getFloors, getRanges };
